import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import LoginComponent from './Login';
import background from '../../img/background.jpg';
import LogoComponent from '../Logo/LogoComponent';
import './styles/LoginContainer.scss';

function LoginContainerComponent() {

  return (
    <div className="login-container" style={{ backgroundImage: `url(${background})` }}>
      <LogoComponent />
      <Container>
        <Row>
          <Col md={5}>
            <LoginComponent />
          </Col>
        </Row>
      </Container>
    </div>
  );

}

export default LoginContainerComponent;
